import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { usePipeline } from '../PipelineContext';

const SERVICE_ICONS = {
  github: '🐙', slack: '💬', jira: '📋', gmail: '📧', notion: '📝',
  airtable: '📊', linear: '📐', twitter: '🐦', discord: '🎮',
  webhook: '🪝', custom: '🔧',
};

const CONNECTION_INFO = {
  what: 'Links your pipeline to an external service. Actions and triggers use connections to interact with APIs, send messages, and automate external systems.',
  examples: ['Twitter — monitor and post tweets via API', 'GitHub — create issues and PRs from workflows'],
};

export default function ConnectionNode({ data, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const { opsMode } = usePipeline() || {};
  const serviceIcon = SERVICE_ICONS[data.serviceType] || '⚡';
  const isConfigured = !!(data.serviceUrl || data.serviceType);

  return (
    <div className={`pipeline-node connection-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle" />

      <div className="node-header connection-header">
        <span className="node-type-icon">{opsMode ? '🔌' : serviceIcon}</span>
        <span className="node-type-label">{opsMode ? 'App' : 'Connection'}</span>
        <button className="node-info-btn" onMouseDown={e => e.stopPropagation()} onClick={e => { e.stopPropagation(); setShowInfo(s => !s); }}>ⓘ</button>
        {isConfigured && (
          <span className="conn-status-dot" style={{ background: data.authToken ? '#10b981' : '#f59e0b' }}
            title={data.authToken ? 'Authenticated' : 'No auth token'} />
        )}
      </div>

      <div className="node-body">
        <div className="node-title">{data.label}</div>
        {data.description && <div className="node-description">{data.description}</div>}
        {data.serviceType && (
          <div className="conn-service-tag">{data.serviceType}</div>
        )}
        {showInfo && (
          <div className="node-info-card">
            <div className="node-info-what">{CONNECTION_INFO.what}</div>
            <div className="node-info-eg-label">Examples:</div>
            {CONNECTION_INFO.examples.map((ex, i) => <div key={i} className="node-info-eg">→ {ex}</div>)}
          </div>
        )}
        {!isConfigured && <div className="coming-soon-badge">Not configured</div>}
      </div>

      <Handle type="source" position={Position.Right} className="node-handle" />
    </div>
  );
}
